export const imageList = [
  "/images/hero/heroLight.webp",
  "/images/hero/heroLightTablet.webp",
  "/images/hero/heroLightMobile.webp",
  "/images/hero/heroDark.webp",
  "/images/hero/heroDarkTablet.webp",
  "/images/hero/heroDarkMobile.webp",
  "/images/whatIDo/front-end-light.png",
  "/images/whatIDo/front-end-dark.png",
  "/images/icons/html.svg",
  "/images/icons/javascript.svg",
  "/images/icons/css.svg",
  "/images/icons/react.svg",
  "/images/whatIDo/backend-servers-light.png",
  "/images/whatIDo/backend-servers-dark.png",
  "/images/icons/nodejs.svg",
  "/images/icons/mongodb.svg",
  "/images/icons/mysql.svg",
  "/images/icons/c.svg",
  "/images/whatIDo/low-fidelity-light.png",
  "/images/whatIDo/low-fidelity-dark.png",
  "/images/icons/figma.svg",
  "/images/icons/adobexd.svg",
  "/images/icons/miro.svg",
  "/images/icons/jira.svg",
  "/images/education/cap-diploma.webp",
  "/images/education/CSUEB.svg",
  "/images/education/DAC_Logo_Black.png",
  "/images/education/DAC_Logo_White.png",
  "/images/education/uc-berkeley.png",
  "/images/education/cisco.png",
  "/images/education/udacity.png",
  "/images/education/sccgov.png",
  "/images/education/udemy.png",
  "/images/education/foothill-college.png",
  "/images/education/sololearn.png",
  "/images/experience/experience-hero-light.webp",
  "/images/experience/experience-hero-dark.webp",
  "/images/projects/project-board-light.webp",
  "/images/projects/project-board-dark.webp",
  "/images/projects/property-match.png",
  "/images/projects/trackerapp.png",
  "/images/projects/urban-gold.png",
  "/images/projects/sdk-portfolio.png",
  "/images/projects/pioneer-polls.png",
  "/images/projects/rov-timer.png",
  "/images/icons/github.svg",
  "/images/icons/redux.svg",
  "/images/icons/materialui.svg",
  "/images/icons/jest.svg",
  "/images/icons/tailwind.svg",
  "/images/icons/nextjs.svg",
  "/images/icons/vercel.svg",
  "/images/contact/animated-me.webp",
];
